<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="80px">
            <el-form-item label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="标引人" prop="createBy">
                <el-select style="width: 100%;" v-model="searchForm.createBy" clearable placeholder="请选择标引人">
                    <el-option
                        v-for="item in applicantList"
                        :key="item.createBy"
                        :label="item.createByName"
                        :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标引时间" prop="createTime">
                <el-date-picker
                        v-model="searchForm.createTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="text_right p_all1">
            <el-button v-if="hasPermission('converge:mark:markManage:export')" type="primary"
                       @click="exportData()"
                       size="small">批量导出
            </el-button>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border
                ref="multipleTable"
                :row-key="'id'"
                @sort-change="sortChangeHandle"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column :reserve-selection="true" type="selection" width="50"/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="labelName" label="标注名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" sortable label="标注时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="标注人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="auditDate" sortable label="审核时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="resourcesName" label="标注资源名称" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-link type="primary" @click="view(row)">{{ row.resourcesName }}</el-link>
                </template>
            </el-table-column>
            <el-table-column fixed="right" min-width="50px" label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="hasPermission(`converge:mark:markManage:retreat`)"
                               type="text" size="small"
                               @click="retreat(row)">退回
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <retreat-mark ref="retreatMark" @refresh="refreshList('',1)"></retreat-mark>
        <resource-add-edit-form ref="resourceAddEditForm" @refreshData="refreshList(1,1)"></resource-add-edit-form>
    </div>
</template>

<script>


import RetreatMark from "@/views/modules/converge/mark/retreatMark.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "markManage",
    components: {ResourceAddEditForm, RetreatMark},
    data() {
        return {
            searchForm: {
                keyword: '',
                createBy:'',
                createTime: [],
                createStartDate: '',
                createEndDate: '',
                orderBy:"",
                current: 1,
                size: 20,
            },
            total: 0,
            applicantList:[],

            loading: false,
            dataList: [],
            dataListSelect: [],

            searchData:{},
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            if (this.searchForm.createTime && this.searchForm.createTime.length != 0) {
                this.searchForm.createStartDate = this.searchForm.createTime[0]
                this.searchForm.createEndDate = this.searchForm.createTime[1]
            } else {
                this.searchForm.createStartDate = ''
                this.searchForm.createEndDate = ''
            }
            this.searchData = this.searchForm
            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData,'createTime')
            this.loading = true
            this.$axios(this.api.academic.resourceslabelLabelList, searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        getOtherList() {
            this.$axios(this.api.academic.resourceslabelResourcesLabelUserList, {}).then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        //排序
        sortChangeHandle (obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //详情 typeName view详情 edit编辑 toExamineView审核详情
        view(row) {
            this.$refs.resourceAddEditForm.init('view', row.resourcesId, '', row.basicDataId,'',row)
        },

        //退回
        retreat(row){
            this.$refs.retreatMark.init(row)
        },

        //导出
        exportData() {
            if (this.total == 0) {
                this.$message.warning('暂无可导出的数据！')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.middleId
            })
            this.exportExcel(this.api.academic.resourceslabelExportLabelData, {
                ids,
                ...this.searchData,
            }, '标注管理', 'post')
        },
    }
}
</script>

<style scoped>

</style>
